$(function() {

	var header = $('.header-wrap');

	if ($(document).scrollTop() > 40) {
        header.addClass('active');
        $('.search-popout').addClass('scrolled');
        $('.product-meta-lightbox').addClass('header-shunt');
    }

	$(window).scroll(function() {
        if ($(document).scrollTop() > 40) {
            header.addClass('active');
            $('.search-popout').addClass('scrolled');
            $('.product-meta-lightbox').addClass('header-shunt');
        }
        else {
            header.removeClass('active');
            $('.search-popout').removeClass('scrolled');
            $('.product-meta-lightbox').removeClass('header-shunt');
        }
    });

	$('.hp-hero').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		autoplay: true,
		speed:1000,
		autoplaySpeed: 3000,
		fade: true,
		pauseOnHover: false,
		pauseOnFocus: false
	});

	$('.title-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		autoplay: true,
		speed:1500,
		autoplaySpeed: 5000,
		fade: true,
		pauseOnHover: false,
		pauseOnFocus: false
	});

	$('.j-review-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		autoplay: true,
		speed:1500,
		autoplaySpeed: 5000,
		fade: true,
		pauseOnHover: false,
		pauseOnFocus: false
	});

	$('.os-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		variableWidth: true,
		swipeToSlide: true,
		pauseOnHover: false,
		pauseOnFocus: false,
		responsive: [
		{
			breakpoint: 600,
				settings: {
					centerMode: true,
					arrows: false
				}
			}
		]
	});

	$('.usp-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		autoplay: true,
		speed:1000,
		autoplaySpeed: 4000,
		fade: true,
		pauseOnHover: false,
		pauseOnFocus: false
	});

	$('.quote-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		autoplay: true,
		speed:500,
		autoplaySpeed: 6000,
		fade: true,
		pauseOnHover: false,
		pauseOnFocus: false,
		responsive: [
		{
			breakpoint: 600,
				settings: {
					adaptiveHeight: true
				}
			}
		]
	});

	$('.j-p-usp-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		autoplay: true,
		speed:500,
		autoplaySpeed: 6000,
		fade: true,
		pauseOnHover: false,
		pauseOnFocus: false
	});

	$(document).on('click', '.os-carousel .slick-next', function(){

		$(this).parent().find('.slick-prev').addClass('active');

	});

	$(document).on('click', '.j-scroll-up', function(e){

		e.preventDefault();
		$('html,body').animate({ scrollTop: 0 }, 'slow');

	});


	// Home animations

    var elements_to_animate = $('.template-index .shopify-section, .instgram, .site-footer, .copyright, .insta-img');

    elements_to_animate.each(function(){

		if ( $(this).visible(true) ){

			$(this).addClass('active');

		}

	});

    $(window).on('scroll', function(){

		elements_to_animate.each(function(){

			if ( $(this).visible(true) ){

				$(this).addClass('active');

			}

		});

	});

	// FAQ 

	$(document).on('click', '.j-faq-title', function(e){

		e.preventDefault();
		$(this).parent().parent().toggleClass('active');

	});

	// Style images on article page

	$('.article-content img').each(function(){

		if ( $(this).attr('alt') == 'half' ){

			$(this).addClass('img-half');
			$(this).parent().addClass('img-flex');

		}

		if ( $(this).attr('alt') == 'full' ){

			$(this).addClass('img-full');
			$(this).parent().addClass('img-flex');

		}

	});

	// Collection JS

	// Sort select onChange

	$(document).on('change', '#sort_list', function(){

		if ( $(this).val() == 'price-low-high' ){
			window.location.replace('?sort_by=price-ascending');
		}

		if ( $(this).val() == 'price-high-low' ){
			window.location.replace('?sort_by=price-descending');
		}

	})

	// Toggle accordion filters

	$(document).on('click', '.cf-list p', function(){

		$(this).parent().toggleClass('active');

	});

	$('.cf-list ul li a').each(function(){

		if ($(this).hasClass('active')){

			$(this).parent().parent().parent().addClass('active');

		}

	});

	// Product page lightbox

	$(document).on('click', '.j-close-plightbox', function(e){
	
		e.preventDefault();
		$(this).parent().removeClass('active');

	});

	$(document).mouseup(function(e) {
	    var p_sidebar = $('.product-meta-lightbox');

	    if (!p_sidebar.is(e.target) && p_sidebar.has(e.target).length === 0) {
	        p_sidebar.removeClass('active');
	    }
	});

	$(document).on('click', '.p-content-triggers a', function(e){

		e.preventDefault();

		$('.product-meta-lightbox').addClass('active');

		var toShow = $(this).data('content');

		$('.product-meta-lightbox .content-wrap').hide();

		$('.product-meta-lightbox .content-wrap.' + toShow + '').show();



	});

	$(document).on('click', '.product-purchase-data .qty_counter span', function(){

        if( $(this).hasClass('minus') ){

            if( $('.product-purchase-data .qty_counter .qty').val() < 2 ){
                console.log('smaller than 0');
            } else {

                var counter = parseInt($('.product-purchase-data .qty_counter .qty').val());
                counter--;
                $(".product-purchase-data .j-quantity-update").val(counter);

            }

        }

        if( $(this).hasClass('plus') ){

            var counter = parseInt($('.product-purchase-data .j-quantity-update').val());
            counter++;
            $(".product-purchase-data .j-quantity-update").val(counter);

        }

    });

    // Add to cart JS

    $(document).on('click', '.add_to_cart', function(e){

        e.preventDefault();

        var original_text = $(this).text();
	    $(this).text('Added to basket!').addClass('added');
	    $('.j-cart-toggle').addClass('hasItems animated swing');

    	setTimeout(function(){

        	$('.add_to_cart').text(original_text).removeClass('added');

        }, 3000);

        var id          = $(this).val();
        var quantity    = $('.product-purchase-data .j-quantity-update').val();

        CartJS.addItem(id, quantity, {}, {
		    "success": function(data, textStatus, jqXHR) {
              dataLayer.push({
                'event': 'addToCart',
                'ecommerce': {
                  'currencyCode': 'GBP',
                  'add': {
                    'products': [{
                      'name': data.title,
                      'id': data.id,
                      'price': data.price,
                      'quantity': data.quantity
                    }]
                  }
                }
              });
		    	
		    }
		});

    });

    // Remove from cart

    $(document).on('click', '.j-cart-item-remove', function(e){

        e.preventDefault();
        var productID = $(this).data('id');
      	var name = $(this).data('name');
      	var price = $(this).data('price');
      	var qty = $(this).data('qty');
		CartJS.removeItemById(productID);
      console.log(name +' , '+price+' , '+qty )
          dataLayer.push({
            'event': 'removeFromCart',
            'ecommerce': {
              'currencyCode': 'GBP',
              'add': {
                'products': [{
                  'name': name,
                  'id': productID,
                  'price': price,
                  'quantity': qty
                }]
              }
            }
          });
		$(this).closest('.cart_item').fadeOut();

    });

    $(document).on('cart.requestComplete', function(event,cart) {
       
        cartRequestComplete();

    });

    // Cart request complete

    function cartRequestComplete() {

  //   	$('.cart-contents-wrapper').load('/ .cart-contents', function(){

		// 	// var original_text = $('.add_to_cart').text();
	 //  //   	$('.add_to_cart').text('Added to basket!');
	 //  //   	$('.cart-sidebar').addClass('active');
	 //  //   	$('.j-update-cart-val').load();


		// 	// jQuery.getJSON('/cart.js', function(cart) {
		// 	// 	$('.j-update-cart-val').text( '(' + cart.item_count + ')' );
		// 	// });

		// });

    }

    // Update quantity on cart

    $(document).on('click', '.cart-contents .qty_counter span', function(){

		var itemID = $(this).parent().find('input').data('id');
		console.log(itemID);
		var qty_selector = $(this).parent();
		qty_selector.css('opacity', 0.3);

		if( $(this).hasClass('minus') ){

			if( $(this).parent().find('.j-quantity-update').val() < 2 ){
				console.log('smaller than 0');
				//$('.update_container').addClass('show');
			} else {

				var counter = parseInt($(this).parent().find('.j-quantity-update').val());
				counter--;
				CartJS.updateItemById(itemID, counter);
				$(this).parent().find('.j-quantity-update').val(counter);

			}

		}

		if( $(this).hasClass('plus') ){

			var counter = parseInt($(this).parent().find('.j-quantity-update').val());
			counter++;
			CartJS.updateItemById(itemID, counter);
			$(this).parent().find('.j-quantity-update').attr('value', counter);

		}

		qty_selector.css('opacity', 1);

	});
    

	
    // Cart toggle

 //    $(document).mouseup(function(e) {
	//     var cart_sidebar = $('.cart-sidebar');

	//     if (!cart_sidebar.is(e.target) && cart_sidebar.has(e.target).length === 0) {
	//         cart_sidebar.removeClass('active');
	//     }
	// });

    // $(document).on('click', '.j-cart-toggle', function(e){

    // 	e.preventDefault();
    // 	$('.cart-sidebar').addClass('active');

    // });

    // $(document).on('click', '.j-close-cart', function(e){

    // 	e.preventDefault();
    // 	$('.cart-sidebar').removeClass('active');

    // });


    // Account JS

    $(document).on('click', '.j-toggle-reset-password', function(e){
	
		e.preventDefault();
		$('#login-form').hide();
		$('#reset-password-form').show();
	
	});

	$(document).on('click', '.j-toggle-login-form', function(e){
	
		e.preventDefault();
		$('#reset-password-form').hide();
		$('#login-form').show();
		
	});


	// Account page

	$(document).on('click', '.account-nav a', function(e){

		if ( $(this).attr('href') == '#' ){
	
			e.preventDefault();
			$(this).addClass('active').parent().siblings().find('a').removeClass('active');
			var active_item = $(this).data('account-menu');
			$('.a-section').removeClass('active');
			$('.a-section.data-' + active_item + '').addClass('active');

			var url = "?page=" + active_item + "";
			//document.location.hash = url;

			history.pushState('data', '', '/account' + url);

		}

	});

	// Toggle address form

	$(document).on('click', '.show_address_form', function(e){
	
		e.preventDefault();
		var formID = $(this).data('form-id');
		$('.edit-address-form').hide();
		$('#EditAddress_' + formID + '').show();
		console.log(formID);
	
	});

	$(document).on('mouseup', '.optin', function(){

		if( $('.j-pract-optin').is(':checked') ){

			$('.j-pract-btn').addClass('disabled');

		} else {

			$('.j-pract-btn').removeClass('disabled');

		}

	});

	$(document).on('click', '.j-mob-menu-trigger', function(e){

		e.preventDefault();
		$(this).toggleClass('active');
		$('.menu-wrapper').toggleClass('active');
		$('.header-wrap').toggleClass('active');

	});

	$(document).on('click', '.j-filter-toggle-mob', function(e){

		e.preventDefault();
		$(this).toggleClass('active');
		$('.c-search-sort').toggleClass('expanded');
		$('.collection-filters').toggleClass('expanded');

	});

	$(document).on('click', '.j-toggle-l-accordion', function(e){

		e.preventDefault();
		$(this).parent().toggleClass('active');

	});

	$(document).on('click', '.l-nav a', function(e){

		e.preventDefault();

		if ( $(this).hasClass('j-scroll-to-harrow') ){

			console.log('scroll to harrow');
			$('html, body').animate({
			    scrollTop: $("#triveda-harrow").offset().top - 100
			 }, 1000);

		} else if ( $(this).hasClass('j-scroll-to-pinner') ){

			console.log('scroll to pinner');
			$('html, body').animate({
			    scrollTop: $("#triveda-pinner").offset().top - 100
			 }, 1000);


		} else {

			console.log('scroll to virtual');
			$('html, body').animate({
			    scrollTop: $("#shopify-section-location-virtual").offset().top - 100
			 }, 1000);

		}

	});

	// Trigger product review lightbox

	$(document).on('click', '.j-show-review-lb', function(e){

		e.preventDefault();
		$('.p-review-lb').fadeIn();

	});

	// Close service lightbox

	$(document).on('click', '.j-close-pr-lb', function(e){

		e.preventDefault();
		$('.p-review-lb').fadeOut();

	});

	// Trigger services lightbox

	$(document).on('click', '.j-trigger-lb', function(e){

		e.preventDefault();
		var service = $(this).data('service');
		console.log(service);
		$('#j-service-val').val(service);
		$('.service-lightbox').fadeIn();

	});

	// Close service lightbox

	$(document).on('click', '.j-close-lb', function(e){

		e.preventDefault();
		$('#j-service-val').val('');
		$('.service-lightbox').fadeOut();

	});

	// Toggle search lb

	$(document).on('click', '.j-search', function(e){

		e.preventDefault();
		$('.search-popout').toggleClass('active');

	});

	$(document).mouseup(function(e) {
	    var search_lb = $('.search-popout.active');

	    if (!search_lb.is(e.target) && search_lb.has(e.target).length === 0) {
	        search_lb.removeClass('active');
	    }
	});

	if ( document.location.href.indexOf('?cart=true') > -1 ) {
        //$('.cart-sidebar').addClass('active');
    }


    if ($(window).width() < 1025) {

    	$(document).on('click', '.j-mob-has-children', function(e){

    		e.preventDefault();

    	});

    }

  $(document).on('click', '.j-price-list-toggle', function(e){
    
    	e.preventDefault();
    	$('.j-price-list-toggle').show().parent().removeClass('active');
    	$(this).hide().parent().addClass('active');
    
  });

  const scrolls = document.getElementsByClassName("announcement-bar")

	Array.from(scrolls).forEach(e => {
	  const childw = e.children[0].offsetWidth
	  const parentw = e.offsetWidth
	  
	  let children = ""
	  for (let i = 0; i < (Math.ceil(parentw / childw) + 1); i++) {
	    children += e.innerHTML
	  }
	  
	  e.innerHTML += children
	})

});